export default __webpack_public_path__ + "img/ccijcXMy.da8bcefd.svg";